import React from 'react';
import { FileTextIcon, PrinterIcon, DownloadIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
const details = [{
  icon: FileTextIcon,
  label: 'Każdy tom i bonus to plik PDF'
}, {
  icon: PrinterIcon,
  label: 'Drukuj dowolną stronę lub udostępniaj cyfrowo'
}, {
  icon: DownloadIcon,
  label: 'Pobierz od razu po zakupie'
}];
export function FormatNotice() {
  return <section aria-labelledby="format-heading" className="bg-night-900 py-14 sm:py-20" data-id="element-155" data-mp="2y2nu7lpvi2a0">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-6" data-id="element-156" data-mp="323znq2bvb7nh">
        <Eyebrow align="center" data-id="element-157" data-mp="323hf0680r0yo">Format</Eyebrow>
        <h2 id="format-heading" className="mt-4 font-display text-3xl leading-[0.98] text-cream sm:text-5xl" data-id="element-158" data-mp="2ocumivsuq7b1">
          Cała zawartość to PDF. <span className="text-amber" data-id="element-159" data-mp="2tae8khvsjodj">Na razie bez filmów.</span>
        </h2>
        <p className="mt-5 font-serif text-lg italic leading-relaxed text-cream-soft" data-id="element-160" data-mp="3h10459olzg6n">
          Dokumenty do druku i edycji, których użyjesz od razu na zajęciach &mdash; bez logowania
          na platformę i bez oglądania kursu wideo.
        </p>
        <ul className="mx-auto mt-8 grid max-w-xl gap-4 text-left sm:grid-cols-3 sm:text-center" data-id="element-161" data-mp="2hthjjc506gup">
          {details.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-3 rounded-xl border border-night-600 bg-night-800 p-4 sm:flex-col" data-id="element-162" data-mp="2rln6u8kb8a3k">
              <Icon className="h-5 w-5 shrink-0 text-amber" aria-hidden="true" data-id="element-163" data-mp="31jjlhacghn6f" />
              <span className="text-xs leading-snug text-cream-soft" data-id="element-164" data-mp="31le4uk82x78e">{label}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}